import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddress from '../../useAddress'

const HeatingEnergy = () => {
  const { t, updateAddress, energyLandscape, heatingEnergy, heatingOptions } = useAddress()

  return (
    <FormControl>
      <SDSelect
        label={t('subscriptionTools:estimator.heating_mode.label')}
        optionsList={heatingOptions}
        onChangeHandler={params =>
          updateAddress({
            heatingEnergy: params.option?.id,
            energyLandscape: {
              ...energyLandscape,
              heatPump: params.option?.id !== 'elec' ? false : energyLandscape.heatPump,
            },
          })
        }
        selectedValue={heatingEnergy ? heatingEnergy.toString() : ''}
        hasError={false}
      />
    </FormControl>
  )
}
export default HeatingEnergy
